import React, { useEffect, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useAppSelector } from '../../../../app/hooks';
import { selectedBatchId } from './batchesSlice';
import { shallowEqual } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export default function ApproveToaster() {
    const selectedBId = useAppSelector(selectedBatchId);

    const { approveBatchLoading, approvedBatchStatus, approveBatchError, isApproved } =
        useAppSelector((state) => {
            return {
                approveBatchLoading: state.batches.approveStatus.loading,
                approvedBatchStatus: state.batches.approveStatus.status,
                approveBatchError: state.batches.approveStatus.error,
                isApproved: state.batches.isApproved,
            };
        }, shallowEqual);

    const [toasterType, setToasterType] = useState<'error' | 'success' | 'none'>('none');
    useEffect(() => {
        if (approvedBatchStatus === 'idle' || approveBatchLoading) {
            setToasterType('none');
        } else if (isApproved) {
            setToasterType('success');
        } else if (approveBatchError) {
            setToasterType('error');
        }
    }, [isApproved, approveBatchError, approvedBatchStatus, approveBatchLoading]);

    const snackBar = (message: string, type: 'error' | 'success') => (
        <Snackbar
            open={toasterType !== 'none'}
            onClose={() => setToasterType('none')}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                severity={type}
                action={
                    <>
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={() => setToasterType('none')}
                            style={{ padding: 4 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </>
                }
            >
                {message}
            </Alert>
        </Snackbar>
    );

    return (
        <>
            {toasterType === 'error' &&
                snackBar(`${approveBatchError}. Batch ${selectedBId} is not approved!`, 'error')}
            {toasterType === 'success' && snackBar(`Batch ${selectedBId} is approved!`, 'success')}
        </>
    );
}
